import { AfterViewInit, Component, ElementRef, ViewChild } from '@angular/core';

import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TablerIconComponent } from '../../../components/tabler-icon/tabler-icon.component';
import { AuthService } from '../../../service/auth/auth.service';

import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { TablerIcon } from '../../../components/tabler-icon/tabler-icon-list';
import { ApiService } from '../../../service/helper/api.service';
import { BlockUiService } from '../../../service/helper/block-ui.service';

type Consent = any
@Component({
  selector: 'app-accept-consent-modal',
  imports: [CommonModule, FormsModule, TablerIconComponent],
  templateUrl: './accept-consent-modal.component.html',
  styleUrl: './accept-consent-modal.component.scss'
})
export class AcceptConsentModalComponent implements AfterViewInit {
  _TablerIcon = TablerIcon;

  @ViewChild('scrollBox') scrollBox!: ElementRef<HTMLDivElement>;

  userDetail: any;
  consent: Consent | null = null;
  isAccept: boolean = false;
  viewOnly: boolean = false;

  consentDetail: SafeHtml | string = ''

  consentScrolledToBottom: boolean = false;

  constructor(
    private apiService: ApiService,
    private blockUI: BlockUiService,
    private authService: AuthService,
    private activeDialog: NgbActiveModal,
    private sanitizer: DomSanitizer
  ) {
    // this.userDetail = this.authService.getUserCredential()

    this.getConsent()
  }

  ngAfterViewInit(): void {
    const el = this.scrollBox.nativeElement;
    if (el.scrollHeight <= el.clientHeight) {
      this.consentScrolledToBottom = true;
    }
  }

  getConsent() {
    this.apiService.get<Consent>('MasterData/GetConsent').subscribe((res) => {
      if (res.body) {
        this.consent = res.body?.data
        this.consentDetail = this.sanitizer.bypassSecurityTrustHtml(this.consent?.detail || '')
      }
    });
  }

  onSubmit() {
    let body = {
      user_id: this.userDetail?.id
    }
    this.apiService.patch('Authen/AcceptLastestConsent', body).subscribe((res) => {
      if (res.body) {
        this.consent = res.body?.data
      }
    });

    this.closeModal();
  }

  closeModal() {
    this.activeDialog.dismiss()
  }

  onScrollConsent(event: Event) {
    const target = event.target as HTMLElement;
    const atBottom = target.scrollHeight - target.scrollTop <= target.clientHeight + 1;

    if (atBottom) {
      this.consentScrolledToBottom = atBottom;
    }
  }

}
